export const jiraProjectAdministorProjectsJql =
	'project IN projectsWhereUserHasPermission("Browse Projects")';
